export const INITIAL_STATE = {
  idToken: null,
  user: null,
  refreshTokenRequestSymbols: [],
  lastLoginSuccess: null,
  accountId: null,
  rgExternalToken: null,
  rgGroupId: null,
};

export default {
  ...INITIAL_STATE,
};
